import { Controller, useFormContext } from 'react-hook-form';

import { Dropdown } from '@ui/components/Dropdown';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const OPTIONS = [
  { value: true, label: 'Когда любой игрок сыграет со всеми соперниками' },
  { value: false, label: 'Отключено' },
];

export function EarlyFinishInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Досрочное завершение</FormLabel>

      <FormInput>
        <Controller
          name="prematureFinishEnabled"
          control={control}
          defaultValue={false}
          render={({ field: { value, onChange, disabled } }) => {
            const onValidChange = (value: string) => {
              onChange(value === 'true');
            };
            return (
              <Dropdown
                options={OPTIONS}
                value={value ? 'true' : 'false'}
                onChange={onValidChange}
                disabled={disabled}
              />
            );
          }}
        />
      </FormInput>
    </FormRow>
  );
}
